export default __webpack_public_path__ + "static/lframe-pay-it-faster-77ec303be730c4930c67261f2e3a8ef4.png";